import React, { useEffect, useReducer, useState } from "react"
import { obterEnderecosBloqueados } from "../../../services/enderecosBloqueados"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { EnderecosBloqueadosInicial } from "../models/enderecosBloqueadosModel"
import { EnderecosBloqueadosActionsTypes } from "./enderecosBloqueadosActions"
import { EnderecosBloqueadosContext } from "./EnderecosBloqueadosContext"
import { enderecosBloqueadosReducer } from "./enderecosBloqueadosReducer"

export function EnderecosBloqueadosContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(enderecosBloqueadosReducer, EnderecosBloqueadosInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterEnderecosBloqueados(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({ type: EnderecosBloqueadosActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <EnderecosBloqueadosContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </EnderecosBloqueadosContext.Provider>
    )
}
